import React from 'react';
import styles from './FilterBar.module.css';

export type QuickFilter = 'mine' | 'unassigned' | 'urgent' | 'sla' | null;

interface FilterBarProps {
  onNewTicket?: () => void;
  status: string;
  onStatusChange: (s: string) => void;
  priority: string;
  onPriorityChange: (p: string) => void;
  module: string;
  onModuleChange: (m: string) => void;
  date: string;
  onDateChange: (d: string) => void;
  staff: string;
  onStaffChange: (s: string) => void;
  /** Server-side quick filter (VP-CS-001): Mine / Unassigned / Urgent / SLA Breached. */
  quickFilter?: QuickFilter;
  onQuickFilterChange?: (f: QuickFilter) => void;
}

const QUICK_FILTERS: Array<{ key: Exclude<QuickFilter, null>; label: string; title: string }> = [
  { key: 'mine', label: 'Mine', title: 'Tickets assigned to me' },
  { key: 'unassigned', label: 'Unassigned', title: 'Tickets with no assignee' },
  { key: 'urgent', label: 'Urgent', title: 'Critical priority tickets' },
  { key: 'sla', label: 'SLA Breached', title: 'Tickets past their SLA due date and not resolved' },
];

export const FilterBar: React.FC<FilterBarProps> = ({
  onNewTicket,
  status, onStatusChange,
  priority, onPriorityChange,
  module, onModuleChange,
  date, onDateChange,
  staff, onStaffChange,
  quickFilter = null,
  onQuickFilterChange,
}) => {
  return (
    <div className={styles.bar}>
      <div className={styles.filters}>
        <div className={styles.quickFilters}>
          {QUICK_FILTERS.map((qf) => {
            const active = quickFilter === qf.key;
            return (
              <button
                key={qf.key}
                type="button"
                className={`${styles.quickFilter} ${active ? styles.quickFilterActive : ''}`}
                title={qf.title}
                aria-pressed={active}
                onClick={() => onQuickFilterChange?.(active ? null : qf.key)}
              >
                {qf.label}
              </button>
            );
          })}
        </div>
        <select className={styles.filter} value={status} onChange={(e) => onStatusChange(e.target.value)}>
          <option value="All">All Statuses</option>
          <option value="Open">Open</option>
          <option value="In Progress">In Progress</option>
          <option value="Waiting">Waiting</option>
          <option value="Resolved">Resolved</option>
          <option value="Closed">Closed</option>
        </select>
        <select className={styles.filter} value={priority} onChange={(e) => onPriorityChange(e.target.value)}>
          <option value="All">All Priorities</option>
          <option value="Critical">Critical</option>
          <option value="High">High</option>
          <option value="Medium">Medium</option>
          <option value="Low">Low</option>
        </select>
        <select className={styles.filter} value={module} onChange={(e) => onModuleChange(e.target.value)}>
          <option value="All">All Modules</option>
          <option value="Payment">Payment</option>
          <option value="Delivery">Delivery</option>
          <option value="Customer">Customer</option>
          <option value="Inventory">Inventory</option>
          <option value="Compliance">Compliance</option>
          <option value="Returns">Returns</option>
        </select>
        <input
          type="date"
          className={styles.filter}
          value={date}
          onChange={(e) => onDateChange(e.target.value)}
          title="Filter to tickets opened on this date"
        />
        <input
          type="text"
          className={styles.filter}
          placeholder="All Staff"
          value={staff}
          onChange={(e) => onStaffChange(e.target.value)}
          title="Filter by assigned staff name"
        />
      </div>
      <button className={styles.newBtn} onClick={onNewTicket}>
        + New Ticket
      </button>
    </div>
  );
};
